import $ from 'jquery';
import '../../../../../scss/widgets/lazy/await-signup-overlay.scss';
import { cssAnimation } from '../../../util/animate-css.js';

/**
 * @param {jQuery | HTMLElement} _container
 */
export default (_container) => {

	/** @type {JQuery} */ // @ts-ignore
	const $container = _container instanceof $ ? _container : $(_container);

	// Setup the event listeners
	$container.on({
		'init-signup': () => {
			// Show the overlay
			initSignupModal($container);
		},
		'signup-complete': (event) => {

			/** @type any */ // @ts-ignore
			const response = event?.originalEvent?.detail || event?.detail || {};

			if (response.success !== true) {
				signupError();
				return;
			}
			signupSuccess(response.redirectUrl);
		},
	});

	// Listen for the form submit error
	mpro.get$D().on('mp-ajax-submit-error', ({ detail }) => {
		signupError();
	});
};

/**
 * @param {JQuery} $container
 */
const initSignupModal = function($container) {

	const { body } = document;
	body.style.overflow = 'hidden';

	// Hide the rest of the content
	cssAnimation($container[0], 'fadeOutUp', 'slow').then(() => {
		$container.hide();
	});

	const $overlay = $(getOverlayTemplate()).appendTo(body);

	cssAnimation($overlay[0], 'fadeInUp', 'fast');
	// Show the overlay
	$overlay.show();
	// Show the process steps
	$overlay.find('.signup-overlay-process').show();
	// Display info animation
	scrollText($overlay, 0);
};

/**
 * @param {JQuery} $overlay
 * @param {number} index
 */
const scrollText = function($overlay, index) {

	const $infoSteps = $overlay.find('.signup-overlay-steps p').eq(index);
	const delay = $infoSteps.data('delay') || 3000;
	const delayShow = (index === 0) ? 0 : delay;

	if (index === 4) {
		$('.signup-overlay-title').html(mpro.langvar('adding_demo_products'));
	}

	$infoSteps.animate({ opacity: 1 }, {
		step: (now) => {
			$infoSteps.css({
				// set transform to translateY to 0
				transform: `translateY(${-1 * (1 - now) * 10}px)`,
			});
		},
		complete: () => {
			$infoSteps.delay(delay).animate({ opacity: 0 }, {
				step: (now) => {
					$infoSteps.css({
						// set transform to translateY to -10px
						transform: `translateY(${-1 * (1 - now) * 10}px)`,
					});
				},
				complete: () => {
					scrollText($overlay, (index + 1) % 5);
				},
			});
		},
	});
};

/**
 * @param {string} url
 */
const signupSuccess = (url) => {
	$('.signup-overlay-button').attr('href', url);
	$('.signup-overlay-process').hide();
	$('.signup-overlay-error').hide();
	$('.signup-overlay-steps').hide();
	$('.signup-overlay-success').fadeIn('slow');
	setTimeout(() => {
		window.location.href = url || '/';
	}, 20_000);
};

const signupError = function() {
	$('.signup-overlay-process').hide();
	$('.signup-overlay-success').hide();
	$('.signup-overlay-steps').hide();
	$('.signup-overlay-error').fadeIn('slow');
	setTimeout(() => {
		window.location.reload();
	}, 20_000);
};

const overlayTemplate = `<div id="signup-overlay" class="signup-overlay" style="display: none;">
	<div class="signup-overlay-process">
		<h2 class="signup-overlay-title">{{ loading_creating_store }}</h2>
		<div class="gears">
			<div class="gear gear-large"></div>
			<div class="gear gear-small"></div>
		</div>
	</div>
	<div class="signup-overlay-success">
		{{ label_store_ready }}
		<svg class="checkmark checkmark-success" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
			<circle class="checkmark-circle" cx="25" cy="25" r="25" fill="none" />
			<path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
		</svg>
		<a href="#" class="btn btn-primary signup-overlay-button">{{ visit_store }}</a>
	</div>
	<div class="signup-overlay-error">
		<h2>{{ message_general_error }}</h2>
		<svg class="checkmark checkmark-error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
			<circle class="checkmark-circle" cx="25" cy="25" r="25" fill="none" />
			<g class="checkmark-check" stroke-linecap="round" fill="none">
				<path d="m15.4 34.8s3.6-4.8 9.6-4.8 9.6 4.8 9.6 4.8" />
				<circle cx="31" cy="18" r=".5" />
				<circle cx="19" cy="18" r=".5" />
			</g>
		</svg>
	</div>
	<div class="signup-overlay-steps">
		<p data-delay="3000">1/5: {{ signup_step_1 }}</p>
		<p data-delay="2500">2/5: {{ signup_step_2 }}</p>
		<p data-delay="2500">3/5: {{ signup_step_3 }}</p>
		<p data-delay="5000">4/5: {{ signup_step_4 }}</p>
		<p data-delay="30000">5/5: {{ signup_step_5 }}</p>
	</div>
</div>`;

const getOverlayTemplate = () => {
	return overlayTemplate
		.replaceAll(/{{\s*([a-z][\w.|]+)\s*}}/gi, (match, p1) => {
			return mpro.langvar(p1);
		});
};